import { SentimentVeryDissatisfied } from '@mui/icons-material';
import { Button } from '@mui/material';
import {
    useCallback, useContext, useEffect, useState
} from 'react';
import { checkImageExists } from '../utilities/utils';
import { IPictureItem } from '../ts/Definitions';
import { SelectedSettingsContext } from '../ts/Contexts';
import { lazyWithRetry } from '../utilities/lazyLoaderUtils';

const ImagePickerDialog = lazyWithRetry(() => (import('../dialogs/ImagePickerDialog')));

interface Props {
    item: IPictureItem,
    defaultImage?: string;
    size?: 'Default' | 'Large' | 'Small' | 'Larger';
    allowFix?: boolean;
    allowUpdate?: boolean;
    updated?: (image: string) => void;
    noImageValidation?: boolean;
    disableImageClickThrough?: boolean;
}

export default ({ size = 'Default', allowFix, item, defaultImage = '', updated, noImageValidation, disableImageClickThrough, allowUpdate }: Props) => {
    const [displayImg, setDisplayImage] = useState(item?.img ?? defaultImage);
    const settings = useContext(SelectedSettingsContext);
    const [imageOK, setImageOK] = useState(true);
    const [imageState, setImageState] = useState(false);

    const handleImageSet = useCallback((imgVal: string, keepVisibleOnFailure = false) => {
        setDisplayImage(imgVal ?? '');
        if (noImageValidation !== false) {
            setImageOK(true);
            return;
        }
        if (!imgVal || imgVal === defaultImage) {
            setImageOK(false);
            return;
        }
        setImageOK(true);
        checkImageExists(imgVal).then(() => {
            setImageOK(true);
        }, () => {
            if (!keepVisibleOnFailure) setImageOK(false);
        });
    }, [noImageValidation, defaultImage]);
    useEffect(() => {
        if (!item) return;
        void settings.findItemImage(item, defaultImage).then(img => {
            handleImageSet(img);
        })
    }, [item, noImageValidation, handleImageSet, settings, defaultImage]);

    const imageSelected = (val: string | undefined) => {
        setImageState(false);
        if (!val) return;
        handleImageSet(val, true);
        if (updated) updated(val);
    }


    const handleImageClick = () => {
        if (!allowUpdate) return;
        setImageState(true);
    }

    return (
        <div style={{ textAlign: 'center' }}>
            {imageOK && <div className='profileItemImage'>
                {(disableImageClickThrough || allowUpdate) && <div>
                    {size === 'Larger' && <img src={displayImg} alt="Item" className="largerItemImage" onClick={handleImageClick} onLoad={() => setImageOK(true)} onError={() => setImageOK(false)} />}
                    {size === 'Large' && <img src={displayImg} alt="Item" className="largeItemImage" onClick={handleImageClick} onLoad={() => setImageOK(true)} onError={() => setImageOK(false)} />}
                    {size === 'Default' && <img src={displayImg} alt="Item" className="itemImage" onClick={handleImageClick} onLoad={() => setImageOK(true)} onError={() => setImageOK(false)} />}
                    {size === 'Small' && <img src={displayImg} alt="Item" className="smallItemImage" onClick={handleImageClick} onLoad={() => setImageOK(true)} onError={() => setImageOK(false)} />}
                </div>}
                {!allowUpdate && !disableImageClickThrough && <a href={displayImg}
                    onClick={(args) => {
                        args.stopPropagation();
                    }}
                    rel="noopener noreferrer"
                    target="_blank">
                    {size === 'Larger' && <img src={displayImg} alt="Item" className="largerItemImage" />}
                    {size === 'Large' && <img src={displayImg} alt="Item" className="largeItemImage" />}
                    {size === 'Default' && <img src={displayImg} alt="Item" className="itemImage" />}
                    {size === 'Small' && <img src={displayImg} alt="Item" className="smallItemImage" />}
                </a>}
            </div>}
            {allowFix && !imageOK && <div className='missingImage'>
                <SentimentVeryDissatisfied />
                <Button style={{ background: '#3f51b5', color: '#FFF' }} onClick={(args) => {
                    args.preventDefault();
                    args.stopPropagation();
                    setImageState(true);
                }}>Fix</Button>
            </div>}
            {
                !allowFix && !imageOK && <div className='missingImage'>
                    <SentimentVeryDissatisfied />
                    <div></div>
                </div>
            }
            {imageState && <ImagePickerDialog
                open={imageState}
                message='Pick an image'
                content={displayImg}
                callback={imageSelected}
            />}
        </div >)
}